const manageUser = {
  manageUser: {
    pageTitle: 'Manage User',
    description: 'Manage and customize user roles, permissions, and available menus for individual users.',
    tabs: {
      manageUsers: 'Manage Users',
      userPermission: 'User Permission',
      menuVisibility: 'Menu Visibility'
    },
    searchPlaceholder: 'Search'
  }
};

export default manageUser;